<template>
  <div
    class="relative overflow-y-hidden bg-gradient-to-r from-[#04022E] via-[#04022E] to-[#04022E]"
  >
    <section
      class="h-full overflow-hidden max-h-[2220px] sm:max-h-[2220px] md:max-h-[2300px] xl:max-h-[2300px] relative bg-gradient-to-r from-[rgba(125, 81, 163, 0)] to-[rgba(68, 76, 152, 1)]"
      style="
        background: linear-gradient(
          to right,
          rgba(68, 76, 152, 1),
          rgba(68, 76, 152, 1),
          rgba(68, 76, 152, 1)
        );
      "
      id="home"
    >
      <!-- Background Image -->
      <!-- class="absolute inset-0 object-cover w-full h-full bg-center bg-repeat-y -z-10"  -->
      <img
        src="@/assets/hero-bg.png"
        class="absolute inset-0 z-10 block object-cover object-bottom w-full h-full bg-repeat-y xl:hidden xl:max-h-full xl:object-contain xl:object-top"
        alt="background-image"
      />
      <img
        src="@/assets/hero-bg-xl.png"
        class="absolute inset-0 z-10 hidden object-cover object-bottom w-full h-full bg-repeat-y xl:block xl:max-h-full xl:object-cover xl:object-top"
        alt="background-image"
      />

      <!-- Content Container -->
      <div
        class="z-30 flex flex-col items-center justify-center w-full px-10 pt-20 sm:px-14 sm:pt-20 md:pt-20 lg:pt-[50px] 2xl:pt-14 lg:px-40 xl:px-72 xl:pt-16 2xl:px-80"
      >
        <!-- Hero Image (Responsive Display) -->
        <div class="flex flex-col items-center justify-center">
          <!-- Desktop Image -->
          <img
            v-motion-pop-visible
            src="@/assets/hero-cleanswipe.png"
            class="z-20 block w-[500px] sm:w-[90%] md:w-[600px] lg:w-[660px] 2xl:w-[800px] mt-10"
            alt="desktop-title-text"
          />

          <!-- Button section -->
          <div
            v-motion-pop-visible
            class="flex flex-nowrap sm:flex-row flex-col justify-center items-center mt-8 z-20 mb-[86px] md:mb-[122px]"
          >
            <!-- Kick Button -->
            <a
              href="https://kick.com/cleanswipe"
              target="_blank"
              rel="noopener noreferrer"
              class="relative transition-transform duration-200 hover:scale-105"
            >
              <img
                src="@/assets/hero-btn1.png"
                alt="Watch Live On Kick"
                class="w-full lg:w-[400px] h-full object-contain"
              />
            </a>

            <!-- Stake Button -->
            <a
              href="https://stake.us/?c=91cd941702&offer=cleanswipe"
              target="_blank"
              rel="noopener noreferrer"
              class="relative transition-transform duration-200 hover:scale-105"
            >
              <img
                src="@/assets/hero-btn2.png"
                alt="Register on Stake"
                class="w-full lg:w-[400px] h-full object-contain"
              />
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- <div class="absolute left-0 right-0 z-40">
      <img
        src="@/assets/slash.png"
        alt="Scrolling Slash Banner"
        class="w-full h-auto object-cover"
      />
    </div> -->

    <div
      class="relative overflow-hidden pb-8 md:pb-[158px] px-4"
    >
      <!-- Gradient Shadow Overlay -->
      <div
        class="absolute inset-0 z-10 pointer-events-none"
        style="background: linear-gradient(to bottom,rgba(3, 16, 65, 1) 10%,rgba(3, 16, 65, 0) 100%);
        "
      ></div>

      <!-- Horizontal Multi-Stop Gradient Overlay -->
      <div
        class="absolute inset-0 z-10 pointer-events-none"
        style="background: linear-gradient(to bottom,rgba(8, 8, 30, 0.7) 0%,rgba(8, 8, 30, 0) 50%,rgba(8, 8, 30, 1) 100%);
        "
      ></div>

      <!-- Overlay Image -->
      <img
        src="@/assets/main-overlay.png"
        alt="Main Overlay"
        class="absolute inset-0 w-full h-full object-cover z-0 opacity-100"
      />

      <!-- Socials Section -->
      <section id="socials" class="relative z-20 pt-[180px] md:pt-[200px]">
        <div
          class="text-[32px] md:text-5xl lg:text-5xl text-white leading-10 font-black text-center font-montserrat"
        >
          SOCIALS
        </div>

        <div
          class="flex flex-wrap flex-row justify-center gap-[40px] sm:gap-[40px] md:gap-[60px] mt-[40px] sm:mt-[70px] md:mt-[100px]"
        >
          <!-- X Button (Box style) -->
          <a
            v-motion-slide-visible-once-bottom
            href="https://x.com/Cleanswipez"
            target="_blank"
            class="shadow-[0_0_20px_#4DE8FC] rounded-lg sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[140px] md:w-[140px] hover:cursor-pointer relative"
          >
            <img
              src="../assets/social-button.png"
              alt="x button"
              class="object-cover w-full h-full"
            />
            <div class="absolute inset-0 flex items-center justify-center">
              <img
                src="../assets/X.png"
                class="object-contain w-12 h-12 sm:w-8 sm:h-8 md:w-14 md:h-14"
                alt="X"
              />
            </div>
          </a>

          <!-- YouTube Button -->
          <a
            v-motion-slide-visible-once-bottom
            href="https://www.youtube.com/@Cleanswipez"
            target="_blank"
            class="shadow-[0_0_20px_#4DE8FC] rounded-lg sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[140px] md:w-[140px] hover:cursor-pointer relative"
          >
            <img
              src="../assets/social-button.png"
              alt="youtube button"
              class="object-cover w-full h-full"
            />
            <div class="absolute inset-0 flex items-center justify-center">
              <img
                src="../assets/youtube.png"
                class="object-contain w-12 h-12 sm:w-8 sm:h-8 md:w-14 md:h-14"
                alt="youtube"
              />
            </div>
          </a>

          <!-- Kick Button -->
          <a
            v-motion-slide-visible-once-bottom
            href="https://kick.com/cleanswipe"
            target="_blank"
            class="shadow-[0_0_20px_#4DE8FC] rounded-lg sm:h-[120px] sm:w-[120px] h-[100px] w-[100px] md:h-[140px] md:w-[140px] hover:cursor-pointer relative"
          >
            <img
              src="../assets/social-button.png"
              alt="kick button"
              class="object-cover w-full h-full"
            />
            <div class="absolute inset-0 flex items-center justify-center">
              <img
                src="../assets/kick.png"
                class="object-contain w-12 h-12 sm:w-8 sm:h-8 md:w-14 md:h-14"
                alt="kick"
              />
            </div>
          </a>
        </div>
      </section>

      <!-- Promotions Section -->
      <section id="promotions" class="relative z-20 pt-[120px] md:pt-[200px]">
        <div
          class="text-[32px] md:text-5xl lg:text-5xl text-white leading-10 font-black text-center font-montserrat mb-20 lg:mb-0"
        >
          PROMOTIONS
        </div>

        <div
          class="flex flex-col items-center justify-center w-full px-4 lg:px-0 sm:mt-10 lg:mt-14"
        >
          <div
            class="grid grid-cols-1 lg:grid-cols-2 gap-10 w-full justify-center items-center max-w-[1200px] place-items-center grid-flow-dense"
          >
            <!-- Promo Card 1 - Stake.com (updated) -->
            <div
              v-motion-pop-visible
              class="relative flex flex-col items-center justify-center lg:items-start w-[370px] max-w-[600px] h-[370px] sm:w-full sm:h-full pb-20 lg:pb-10 overflow-hidden text-center bg-center bg-no-repeat bg-contain lg:bg-contain bg-promo-card1-bg-sm lg:bg-promo-card1-bg"
            >
              <div class="relative z-10 px-6 pt-6 md:pt-4 lg:pt-0 lg:px-4">
                <div
                  class="flex flex-col p-4 mt-6 md:gap-8 w-full lg:w-[500px] lg:h-full lg:gap-0 lg:mt-8"
                >
                  <div
                    class="flex flex-col items-center mt-4 lg:mt-0 w-[300px] sm:w-[320px] lg:w-[360px] xl:w-[400px] justify-center py-4 text-lg text-white lg:items-start font-lato"
                  >
                    <img
                      src="@/assets/stake-logo.avif"
                      class="w-[140px] sm:w-[180px] md:w-[220px] lg:w-[100px] xl:w-[120px]"
                      alt="promo stake"
                    />
                    <h1
                      class="mt-6 lg:leading-8 xl:leading-10 text-white text-center lg:text-start lg:text-[20px] xl:text-[24px] font-base"
                    >
                      REGISTER NOW TO GET <br />
                      <span
                        class="lg:text-[24px] xl:text-[32px] font-black bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] text-transparent bg-clip-text"
                      >
                        EXCITING REWARDS
                        <span
                          class="bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] text-transparent bg-clip-text"
                        >
                          EVERYDAY</span
                        ><span class="text-white">!</span>
                      </span>
                    </h1>
                    <h3
                      class="text-center text-white font-base lg:text-[20px] xl:text-[24px]"
                    >
                      USE CODE:
                      <span
                        class="text-transparent font-montserrat text-[30px] md:text-[32px] lg:text-[24px] xl:text-[32px] font-black bg-clip-text bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF]"
                      >
                        CLEANSWIPE
                      </span>
                    </h3>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center gap-4 mt-6 lg:justify-start lg:items-start lg:flex-row"
                  >
                    <a
                      href="https://stake.com/?c=91cd941702&offer=cleanswipe"
                      class="skew-x-[-20deg] w-[280px] lg:w-[300px] xl:w-[340px] flex justify-center items-center text-white font-bold py-6 shadow-2xl bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] hover:border-none"
                    >
                      <span
                        class="skew-x-[20deg] w-full text-white font-extrabold text-sm md:text-md"
                      >
                        REGISTER ON STAKE.COM
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Promo Card 2 - Stake.com -->
            <div
              v-motion-pop-visible
              class="relative flex flex-col items-center justify-center lg:items-start w-[370px] max-w-[600px] h-[370px] sm:w-full sm:h-full pb-20 lg:pb-10 overflow-hidden text-center bg-center bg-no-repeat bg-contain lg:bg-contain bg-promo-card2-bg-sm lg:bg-promo-card2-bg"
            >
              <div class="relative z-10 px-6 pt-6 md:pt-4 lg:pt-0 lg:px-4">
                <div
                  class="flex flex-col p-4 mt-6 md:gap-8 w-full lg:w-[500px] lg:h-full lg:gap-0 lg:mt-8"
                >
                  <div
                    class="flex flex-col items-center mt-4 lg:mt-0 w-[300px] sm:w-[320px] lg:w-[360px] xl:w-[400px] justify-center py-4 text-lg text-white lg:items-start font-lato"
                  >
                    <img
                      src="@/assets/stake-logo.avif"
                      class="w-[140px] sm:w-[180px] md:w-[220px] lg:w-[100px] xl:w-[120px]"
                      alt="promo stake"
                    />

                    <!-- Updated Text -->
                    <h2
                      class="mt-6 text-white text-center lg:text-start text-[16px] md:text-[18px] lg:text-[18px] xl:text-[22px] font-base"
                    >
                      TUNE IN FOR A CHANCE TO BE
                    </h2>

                    <h1
                      class="leading-tight text-center lg:text-start text-[20px] md:text-[22px] lg:text-[22px] xl:text-[32px] font-black bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] text-transparent bg-clip-text font-montserrat"
                    >
                      THE LUCKY WINNER <br />
                      OF A BONUS BUY!
                    </h1>

                    <p
                      class="text-white text-center lg:text-start text-[14px] md:text-[16px] xl:text-[18px] font-semibold mt-1"
                    >
                      AND OTHER GIVEAWAYS!
                    </p>
                  </div>

                  <div
                    class="flex flex-col items-center justify-center gap-4 mt-6 lg:justify-start lg:items-start lg:flex-row"
                  >
                    <a
                      href="https://kick.com/cleanswipe"
                      class="skew-x-[-20deg] w-[280px] lg:w-[300px] xl:w-[340px] flex justify-center items-center text-white font-bold py-6 shadow-2xl bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] hover:border-none"
                    >
                      <span
                        class="skew-x-[20deg] w-full text-white font-extrabold text-sm md:text-md"
                      >
                        WATCH STREAM AT KICK.COM
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Leaderboard Section -->
      <section
        id="leaderboards"
        class="relative z-20 h-auto leaderboard-bg mt-24 md:mt-[174px] scroll-mt-20"
      >
        <div
          class="flex items-center justify-center w-full px-4 md:px-8 lg:pt-0"
        >
          <div
            class="flex flex-col items-center justify-center w-full my-8 md:my-10 md:p-8 rounded-3xl"
          >
            <div
              v-motion-pop-visible
              class="text-white text-2xl font-black md:text-[48px] text-center leading-[48px]"
              style="font-family: Montserrat, sans-serif"
            >
              {{ currentPrizeTitle }}
              <span
                class="text-transparent bg-clip-text bg-gradient-to-r from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] font-[900]"
                >LEADERBOARD</span
              >
            </div>

            <!-- Timer -->
            <div class="flex items-center justify-center mt-10 md:mt-32">
              <div
                v-if="['stake', 'only-stake'].includes(currentLeaderboard)"
                class="flex flex-row items-center justify-center gap-3"
                style="font-family: Oxanium"
              >
                <div class="bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] h-[70px] w-[70px]">
                  <h4 class="text-white text-[36px] leading-[46px] font-bold text-center">
                    {{ timer.split(" ")[0].slice(0, -1) }}
                  </h4>
                  <h6 class="text-sm font-bold leading-6 text-center text-white">DAYS</h6>
                </div>
                <div class="bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] h-[70px] w-[70px]">
                  <h4 class="text-white text-[36px] leading-[46px] font-bold text-center">
                    {{ timer.split(" ")[1].slice(0, -1) }}
                  </h4>
                  <h6 class="text-sm font-bold leading-6 text-center text-white">HRS</h6>
                </div>
                <div class="bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] h-[70px] w-[70px]">
                  <h4 class="text-white text-[36px] leading-[46px] font-bold text-center">
                    {{ timer.split(" ")[2].slice(0, -1) }}
                  </h4>
                  <h6 class="text-sm font-bold leading-6 text-center text-white">MIN</h6>
                </div>
                <div class="bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] h-[70px] w-[70px]">
                  <h4 class="text-white text-[36px] leading-[46px] font-bold text-center">
                    {{ timer.split(" ")[3].slice(0, -1) }}
                  </h4>
                  <h6 class="text-sm font-bold leading-6 text-center text-white">SEC</h6>
                </div>
              </div>
            </div>

            <div
              class="flex items-center justify-center gap-4"
            >
              <!-- ACTIVE Button -->
              <div
                @click="
                  previousLeaderboard = false;
                  changeLeaderboard();
                "
                class="cursor-pointer relative skew-x-[-20deg] flex h-[62px] w-[160px] items-center justify-center py-6 mt-8"
                :class="
                  !previousLeaderboard
                    ? 'bg-gradient-to-r from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF]'
                    : 'border-gradient'
                "
              >
                <p
                  class="text-center skew-x-[20deg] text-lg font-extrabold md:leading-[28px]"
                  :class="
                    !previousLeaderboard
                      ? 'text-white'
                      : 'bg-gradient-to-r from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] text-transparent whitespace-nowrap bg-clip-text'
                  "
                >
                  ACTIVE
                </p>
              </div>

              <!-- ENDED Button -->
              <div
                @click="
                  previousLeaderboard = true;
                  changeLeaderboard();
                "
                class="cursor-pointer relative skew-x-[-20deg] flex h-[62px] w-[160px] items-center justify-center py-6 mt-8"
                :class="
                  previousLeaderboard
                    ? 'bg-gradient-to-r from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF]'
                    : 'border-gradient'
                "
              >
                <p
                  class="text-center skew-x-[20deg] text-lg font-extrabold md:leading-[28px]"
                  :class="
                    previousLeaderboard
                      ? 'text-white'
                      : 'bg-gradient-to-r from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] text-transparent whitespace-nowrap bg-clip-text'
                  "
                >
                  ENDED
                </p>
              </div>
            </div>

            <div class="flex flex-col items-center justify-center mt-24 md:mt-28 mb-10">
              <div class="p-1 bg-transparent rounded-full">
                <div class="bg-transparent" style="font-family: Oxanium">
                  <!-- Desktop leaderboard type switch: Stake / Only on Stake -->
                  <div class="flex items-center justify-center">
                    <label
                      class="relative flex items-center rounded-full w-[280px] sm:w-[320px] h-[90px] lg:w-[420px] lg:h-[100px] p-1 border border-[rgba(255,255,255,0.2)] bg-gradient-to-bl from-[rgba(255,255,255,0.1)] to-[rgba(221,221,221,0.2)] backdrop-blur-[50px]"
                    >
                      <div
                        class="absolute top-1 bottom-1 left-1 w-[calc(50%-4px)] h-[calc(100%-8px)] rounded-full transition-all duration-300 ease-in-out bg-gradient-to-bl from-[#6B75CA] to-[#1BF3FF]"
                        :class="{
                          'translate-x-0': currentLeaderboard === 'stake',
                          'translate-x-full': currentLeaderboard === 'only-stake',
                        }"
                      ></div>

                      <div
                        class="z-20 flex flex-col items-center justify-center w-1/2 h-full gap-1 transition-all rounded-full cursor-pointer"
                        @click="toggleLeaderboard('stake')"
                      >
                        <img
                          src="@/assets/stake-logo.avif"
                          alt="Stake"
                          class="h-[28px] md:h-[34px] w-auto object-contain"
                        />
                        <span
                          class="text-[9px] md:text-[10px] font-bold tracking-widest text-white uppercase"
                          style="font-family: Montserrat, sans-serif"
                          >Stake</span
                        >
                      </div>

                      <div
                        class="z-20 flex flex-col items-center justify-center w-1/2 h-full gap-1 transition-all rounded-full cursor-pointer"
                        @click="toggleLeaderboard('only-stake')"
                      >
                        <img
                          src="@/assets/stake-logo.avif"
                          alt="Only on Stake"
                          class="h-[28px] md:h-[34px] w-auto object-contain"
                        />
                        <span
                          class="text-[9px] md:text-[10px] font-bold tracking-widest text-white uppercase text-center leading-tight"
                          style="font-family: Montserrat, sans-serif"
                          >Only on Stake</span
                        >
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Skeleton loader -->
            <div v-if="loading == true" class="relative w-full mt-28 animate-pulse">
              <div
                class="flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-12 lg:gap-[44px] w-full max-w-[1200px] mx-auto mt-20 lg:mt-14 px-4"
              >
                <div class="order-2 lg:order-1 flex flex-col items-center w-full max-w-[340px] sm:max-w-[380px] lg:w-[380px] lg:-mt-2">
                  <div
                    class="rounded-[10px] w-full h-[260px] lg:h-[360px] bg-gradient-to-r from-[#FFFFFF15] to-[#D9D9D90B] border-2 border-[#1bf3ff]/30"
                  ></div>
                </div>
                <div
                  class="order-1 lg:order-2 flex flex-col items-center w-full max-w-[340px] sm:max-w-[380px] lg:w-[380px] lg:-mt-40"
                >
                  <div
                    class="rounded-[10px] w-full h-[290px] lg:h-[400px] bg-gradient-to-r from-[#FFFFFF15] to-[#D9D9D90B] border-2 border-[#1bf3ff]/30"
                  ></div>
                </div>
                <div class="order-3 flex flex-col items-center w-full max-w-[340px] sm:max-w-[380px] lg:w-[380px] lg:mt-16">
                  <div
                    class="rounded-[10px] w-full h-[260px] lg:h-[360px] bg-gradient-to-r from-[#FFFFFF15] to-[#D9D9D90B] border-2 border-[#1bf3ff]/30"
                  ></div>
                </div>
              </div>

              <div class="flex justify-center mt-8 lg:mt-[91px] mb:mb-24">
                <div
                  class="w-full lg:max-w-[1200px] rounded-[20px] border-2 border-[#1bf3ff]/30 bg-gradient-to-r from-[#FFFFFF15] to-[#D9D9D90B] p-4 md:p-6 space-y-3"
                >
                  <div
                    v-for="n in skeletonRowCount"
                    :key="n"
                    class="h-10 md:h-12 rounded bg-[#FFFFFF12]"
                  ></div>
                </div>
              </div>
            </div>

            <!-- stake leaderboard -->
            <div
              v-if="loading == false && ['stake', 'only-stake'].includes(currentLeaderboard)"
              class="relative w-full mt-28"
            >
              <div
                class="flex flex-col lg:flex-row justify-center lg:justify-between items-center gap-16 lg:gap-[44px] w-full max-w-[1200px] mx-auto mt-20 lg:mt-14 px-4"
              >
                <!-- 2nd Place -->
                <div
                  v-motion
                  :initial="{ opacity: 0, y: 160 }"
                  :visible="{
                    opacity: 1,
                    y: 0,
                    transition: { type: 'spring', stiffness: 320, damping: 22, delay: 60 },
                  }"
                  class="order-2 lg:order-1 flex flex-col items-center w-full max-w-[340px] sm:max-w-[380px] lg:w-[380px] lg:-mt-2"
                >
                  <div
                    class="p-2.5 rounded-[10px] w-full bg-gradient-to-b from-[#C7CBD6]/[0.14] via-[#C7CBD6]/[0.04] to-transparent border-2 border-[#C7CBD6]/70 shadow-[0_0_30px_rgba(199,203,214,0.12)]"
                  >
                    <div
                      class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                    >
                      <img
                        src="../assets/cleanswipe-logo.png"
                        class="absolute inset-0 w-full h-full object-contain opacity-20 pointer-events-none"
                        style="
                          mask-image: linear-gradient(to bottom, black 0%, transparent 75%);
                          -webkit-mask-image: linear-gradient(
                            to bottom,
                            black 0%,
                            transparent 75%
                          );
                        "
                        alt=""
                      />
                      <img
                        src="../assets/crown-silver.png"
                        class="absolute -top-1 left-1/2 -translate-x-1/2 -mt-16 lg:-mt-20 z-20 w-14 lg:w-16"
                        alt="2nd-crown"
                      />
                      <div
                        class="absolute top-0 left-1/2 -translate-x-1/2 -mt-8 lg:-mt-10 z-20 flex items-center justify-center w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-gradient-to-br from-[#E8EAF0] to-[#B8BFCC] text-black text-2xl lg:text-3xl font-[900] shadow-[0_0_20px_rgba(200,210,225,0.35)]"
                      >
                        2
                      </div>
                      <div
                        class="relative flex flex-col justify-center items-center mt-5 lg:mt-8 pb-3 lg:pb-5 rounded-[10px]"
                      >
                        <p
                          class="text-base sm:text-xl lg:text-[25px] lg:leading-9 bg-clip-text bg-gradient-to-r text-transparent from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] overflow-hidden whitespace-nowrap text-ellipsis max-w-[220px] lg:max-w-[264px] mt-2"
                          style="font-family: Russo One, system-ui"
                        >
                          {{ top3.length > 0 ? maskString(top3[1]?.username) : "" }}
                        </p>
                        <p
                          class="text-white text-xl sm:text-2xl font-black uppercase mt-1 lg:mt-9 overflow-hidden whitespace-nowrap text-ellipsis max-w-[220px] lg:max-w-[264px]"
                          style="font-family: Montserrat, sans-serif"
                        >
                          ${{ top3.length > 0 ? top3[1]?.wagered : "" }}
                        </p>
                        <p
                          class="bg-clip-text bg-gradient-to-r text-transparent from-[#E8EAF0] to-[#B8BFCC] text-xs lg:text-sm uppercase"
                          style="font-family: Lato, sans-serif"
                        >
                          Wagered:
                        </p>
                        <div
                          class="mt-2 lg:mt-4 skew-x-[-20deg] relative px-8 py-2.5 lg:py-[21px] lg:px-16 bg-gradient-to-r from-[#E8EAF0] to-[#B8BFCC]"
                        >
                          <p
                            class="skew-x-[20deg] text-black font-extrabold text-lg sm:text-xl md:text-2xl"
                            style="font-family: Lato, sans-serif"
                          >
                            {{ getRewardValue(1) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 1st Place -->
                <div
                  v-motion
                  :initial="{ opacity: 0, y: 220 }"
                  :visible="{
                    opacity: 1,
                    y: 0,
                    transition: { type: 'spring', stiffness: 300, damping: 20, delay: 0 },
                  }"
                  class="order-1 lg:order-2 flex flex-col items-center w-full max-w-[340px] sm:max-w-[380px] lg:w-[380px] lg:-mt-40 relative z-10"
                >
                  <div
                    class="p-2.5 rounded-[10px] w-full bg-gradient-to-b from-[#6B75CA]/[0.18] via-[#1BF3FF]/[0.05] to-transparent border-2 border-[#1bf3ff] shadow-[0_0_40px_rgba(27,243,255,0.18)]"
                  >
                    <div
                      class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                    >
                      <img
                        src="../assets/cleanswipe-logo.png"
                        class="absolute inset-0 w-full h-full object-contain opacity-25 pointer-events-none"
                        style="
                          mask-image: linear-gradient(to bottom, black 0%, transparent 75%);
                          -webkit-mask-image: linear-gradient(
                            to bottom,
                            black 0%,
                            transparent 75%
                          );
                        "
                        alt=""
                      />
                      <div
                        class="absolute -top-0 left-1/2 -translate-x-1/2 -mt-20 lg:-mt-24 z-20 w-16 lg:w-20"
                      >
                        <img
                          src="../assets/crown-gold.png"
                          class="w-16 lg:w-20 animate-bounce-subtle"
                          alt="1st-crown"
                        />
                      </div>
                      <div class="absolute top-0 left-1/2 -translate-x-1/2 -mt-9 lg:-mt-11 z-20">
                        <div
                          class="flex items-center justify-center w-16 h-16 lg:w-20 lg:h-20 rounded-full bg-gradient-to-r from-[#6B75CA] to-[#1BF3FF] text-white text-3xl lg:text-4xl font-[900] shadow-[0_0_30px_rgba(27,243,255,0.4)]"
                        >
                          1
                        </div>
                      </div>
                      <div
                        class="relative flex flex-col justify-center items-center mt-5 lg:mt-8 pb-3 lg:pb-5 rounded-[10px]"
                      >
                        <p
                          class="text-base sm:text-xl lg:text-[25px] lg:leading-9 bg-clip-text bg-gradient-to-r text-transparent from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] overflow-hidden whitespace-nowrap text-ellipsis max-w-[220px] lg:max-w-[264px] mt-2"
                          style="font-family: Russo One, system-ui"
                        >
                          {{ top3.length > 0 ? maskString(top3[0]?.username) : "" }}
                        </p>
                        <p
                          class="text-white text-xl sm:text-2xl font-black uppercase mt-1 lg:mt-9 overflow-hidden whitespace-nowrap text-ellipsis max-w-[220px] lg:max-w-[264px]"
                          style="font-family: Montserrat"
                        >
                          ${{ top3.length > 0 ? top3[0]?.wagered : "" }}
                        </p>
                        <p
                          class="bg-clip-text bg-gradient-to-r text-transparent from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] text-xs lg:text-sm uppercase"
                          style="font-family: Lato, sans-serif"
                        >
                          Wagered:
                        </p>
                        <div
                          class="mt-2 lg:mt-4 skew-x-[-20deg] relative px-8 py-2.5 lg:py-[21px] lg:px-16 bg-gradient-to-r from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF]"
                        >
                          <p
                            class="skew-x-[20deg] text-white font-extrabold text-lg sm:text-xl md:text-2xl"
                            style="font-family: Lato, sans-serif"
                          >
                            {{ getRewardValue(0) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 3rd Place -->
                <div
                  v-motion
                  :initial="{ opacity: 0, y: 160 }"
                  :visible="{
                    opacity: 1,
                    y: 0,
                    transition: { type: 'spring', stiffness: 320, damping: 22, delay: 120 },
                  }"
                  class="order-3 flex flex-col items-center w-full max-w-[340px] sm:max-w-[380px] lg:w-[380px] lg:mt-16"
                >
                  <div
                    class="p-2.5 rounded-[10px] w-full bg-gradient-to-b from-[#F97316]/[0.16] via-[#F97316]/[0.04] to-transparent border-2 border-[#F97316]/70 shadow-[0_0_30px_rgba(249,115,22,0.12)]"
                  >
                    <div
                      class="relative flex flex-col items-center justify-center pt-2 lg:px-6 lg:py-4 rounded-3xl"
                    >
                      <img
                        src="../assets/cleanswipe-logo.png"
                        class="absolute inset-0 w-full h-full object-contain opacity-20 pointer-events-none"
                        style="
                          mask-image: linear-gradient(to bottom, black 0%, transparent 75%);
                          -webkit-mask-image: linear-gradient(
                            to bottom,
                            black 0%,
                            transparent 75%
                          );
                        "
                        alt=""
                      />
                      <img
                        src="../assets/crown-bronze.png"
                        class="absolute -top-1 left-1/2 -translate-x-1/2 -mt-16 lg:-mt-20 z-20 w-14 lg:w-16"
                        alt="3rd-crown"
                      />
                      <div
                        class="absolute top-0 left-1/2 -translate-x-1/2 -mt-8 lg:-mt-10 z-20 flex items-center justify-center w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-gradient-to-br from-[#FB923C] to-[#EA580C] text-white text-2xl lg:text-3xl font-[900] shadow-[0_0_20px_rgba(234,88,12,0.35)]"
                      >
                        3
                      </div>
                      <div
                        class="relative flex flex-col justify-center items-center mt-5 lg:mt-8 pb-3 lg:pb-5 rounded-[10px]"
                      >
                        <p
                          class="text-base sm:text-xl lg:text-[25px] lg:leading-9 bg-clip-text bg-gradient-to-r text-transparent from-[#6B75CA] via-[#1BF3FF] to-[#1BF3FF] overflow-hidden whitespace-nowrap text-ellipsis max-w-[220px] lg:max-w-[264px] mt-2"
                          style="font-family: Russo One, system-ui"
                        >
                          {{ top3.length > 0 ? maskString(top3[2]?.username) : "" }}
                        </p>
                        <p
                          class="text-white text-xl sm:text-2xl font-black uppercase mt-1 lg:mt-9 overflow-hidden whitespace-nowrap text-ellipsis max-w-[220px] lg:max-w-[264px]"
                          style="font-family: Montserrat, sans-serif"
                        >
                          ${{ top3.length > 0 ? top3[2]?.wagered : "" }}
                        </p>
                        <p
                          class="bg-clip-text bg-gradient-to-r text-transparent from-[#FB923C] to-[#EA580C] text-xs lg:text-sm uppercase"
                          style="font-family: Lato, sans-serif"
                        >
                          Wagered:
                        </p>
                        <div
                          class="mt-2 lg:mt-4 skew-x-[-20deg] relative px-8 py-2.5 lg:py-[21px] lg:px-16 bg-gradient-to-r from-[#FB923C] to-[#EA580C]"
                        >
                          <p
                            class="skew-x-[20deg] text-white font-extrabold text-lg sm:text-xl md:text-2xl"
                            style="font-family: Lato, sans-serif"
                          >
                            {{ getRewardValue(2) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex justify-center mt-8 lg:mt-[91px] mb:mb-24">
                <table
                  class="w-full lg:max-w-[1200px] border-separate border-spacing-y-6 bg-gradient-to-r from-[#FFFFFF15] to-[#D9D9D90B] rounded-[20px] border-2 border-[#1bf3ff]"
                >
                  <thead
                    v-motion-slide-visible-once-bottom
                    class="bg-transparent"
                    style="font-family: Montserrat, sans-serif"
                  >
                    <tr>
                      <th
                        class="text-right pl-4 pr-2 md:px-5 lg:px-[45px] xl:pr-12 xl:pl-24 py-2 md:py-4 text-white text-[18px] leading-6 font-bold rounded-l"
                      >
                        RANK
                      </th>
                      <th
                        class="px-1 md:px-5 lg:px-[45px] xl:px-2 py-2 md:py-4 text-white text-[18px] leading-6 font-bold text-center"
                      >
                        USER
                      </th>
                      <th
                        class="px-1 md:px-5 lg:px-[45px] xl:px-2 py-2 md:py-4 text-white text-[18px] leading-6 font-bold text-center"
                      >
                        WAGERED
                      </th>
                      <th
                        class="pr-4 pl-1 text-left md:px-5 lg:px-[45px] xl:pl-12 xl:pr-24 py-2 md:py-4 text-white text-[18px] leading-6 font-bold rounded-r"
                      >
                        PRIZE
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-motion-slide-visible-once-bottom
                      v-for="(item, index) in topRest"
                      :key="index"
                      style="font-family: Lato, sans-serif"
                      class="bg-transparent rounded"
                    >
                      <td
                        class="px-2 md:px-5 lg:px-[45px] xl:px-12 py-2 md:py-4 whitespace-nowrap text-base font-normal text-right uppercase"
                        style="font-family: Russo One, system-ui"
                      >
                        <div class="text-white tracking-[4px]">
                          {{ getOrdinalSuffix(index + 4) }}
                        </div>
                      </td>
                      <td
                        class="px-2 md:px-5 max-w-[76px] overflow-hidden text-ellipsis md:max-w-full lg:px-[45px] xl:px-28 py-2 md:py-5 whitespace-nowrap text-base text-white font-normal text-center tracking-[4px]"
                      >
                        {{ maskString(item.username) }}
                      </td>
                      <td
                        class="px-1 md:px-5 lg:px-[45px] xl:px-28 py-2 md:py-5 whitespace-nowrap text-base text-white font-normal text-center tracking-[4px]"
                      >
                        ${{ item.wagered }}
                      </td>
                      <td
                        class="px-1 text-left md:px-5 lg:px-[45px] xl:px-12 py-2 md:py-5 whitespace-nowrap text-base text-white font-black tracking-[4px]"
                      >
                        <span class="text-inherit text-[#43F7EE]">
                          {{ getRewardValue(index + 3).charAt(0) }}
                        </span>
                        {{ getRewardValue(index + 3).substring(1) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";

export default {
  name: "LeaderboardSection",
  data() {
    return {
      leaderboardData: {},
      leaderboardPrevData: {},
      top3: [],
      topRest: [],
      timer: "0d 0h 0m 0s",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalPrize: 0,
      currentLeaderboard: "stake",
      previousLeaderboard: false,
      startDate: null,
      endDate: null,
      notFormattedEndDate: null,
      loading: false,
      timerInterval: null,
    };
  },
  watch: {
    previousLeaderboard() {
      this.changeLeaderboard();
      this.startTimer();
    },
    currentLeaderboard() {
      this.fetchLeaderboard();
    },
  },
  computed: {
    skeletonRowCount() {
      if (this.currentLeaderboard === "stake") return 12;
      return 7;
    },
    currentPrizeTitle() {
      let prizeText = "";
      if (this.currentLeaderboard === "stake") {
        prizeText = "MONTHLY STAKE";
      } else if (this.currentLeaderboard === "only-stake") {
        prizeText = "ONLY ON STAKE";
      }
      const formattedPrize = this.totalPrize.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return `$${formattedPrize} ${prizeText}`;
    },
  },
  methods: {
    toggleLeaderboard(type) {
      if (this.currentLeaderboard === type) return;
      this.currentLeaderboard = type;
      this.previousLeaderboard = false;
    },

    async fetchLeaderboard() {
      this.loading = true;
      this.leaderboardData = {};
      this.leaderboardPrevData = {};
      this.top3 = [];
      this.topRest = [];

      const baseUrl = process.env.VUE_APP_BASE_API_DYNAMIC;
      const apiKey = process.env.VUE_APP_X_API_KEY_DYNAMIC;
      const secretKey = process.env.VUE_APP_X_SECRET_KEY;

      try {
        const headers = {
          "x-api-key": apiKey,
          ...(["stake", "only-stake"].includes(this.currentLeaderboard) &&
            secretKey && {
              "x-secret-key": secretKey,
            }),
        };

        const isStakeType = ["stake", "only-stake"].includes(this.currentLeaderboard);
        const endpointPath = isStakeType
          ? "/api/leaderboard/stake"
          : `/api/leaderboard/${this.currentLeaderboard}`;

        const params = {};
        if (this.currentLeaderboard === "only-stake") {
          params.isStakeExclusive = "true";
        }

        const res = await axios.get(`${baseUrl}${endpointPath}`, {
          headers,
          params,
        });

        this.leaderboardData = this.normalizeLeaderboardData(res.data);
        this.startDate = moment(res.data.startDate).format("MMMM DD, YYYY");
        this.endDate = moment(res.data.endDate).format("MMMM DD, YYYY");
        this.notFormattedEndDate = res.data.endDate;

        if (this.shouldFetchPreviousLeaderboard()) {
          const prevRes = await axios.get(`${baseUrl}${endpointPath}`, {
            headers,
            params: {
              ...params,
              previous: "true",
            },
          });
          this.leaderboardPrevData = this.normalizeLeaderboardData(prevRes.data);
        }

        this.changeLeaderboard();
        this.startTimer();
      } catch (e) {
        console.error("Leaderboard fetch error", e);
      } finally {
        this.loading = false;
      }
    },

    normalizeLeaderboardData(data) {
      if (!data || !data.leaderboard) return { leaderboard: [] };
      return {
        startDate: data.startDate,
        endDate: data.endDate,
        leaderboard: data.leaderboard.map((entry) => ({
          username: this.getUsername(entry),
          wagered: this.formatCurrency(this.getWageredAmount(entry)),
        })),
      };
    },

    getUsername(entry) {
      switch (this.currentLeaderboard) {
        case "stake":
        case "only-stake":
          return entry.userName || entry.username || "---";
        default:
          return entry.username || entry.userName || "---";
      }
    },

    getWageredAmount(entry) {
      let raw =
        entry.weightedWagered !== undefined && entry.weightedWagered !== null
          ? entry.weightedWagered
          : entry.wagered || 0;

      if (typeof raw === "string") {
        raw = Number(raw.replace(/[^\d.-]+/g, ""));
      }

      return raw;
    },

    leaderboardEnvKey() {
      return this.currentLeaderboard.toUpperCase().replace(/-/g, "_");
    },

    shouldFetchPreviousLeaderboard() {
      const key = `VUE_APP_SHOW_PREVIOUS_LEADERBOARD_${this.leaderboardEnvKey()}`;
      return process.env[key] === "true";
    },

    formatCurrency(amount) {
      if (typeof amount !== "number") return "---";
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    changeLeaderboard() {
      const source = this.previousLeaderboard
        ? this.leaderboardPrevData
        : this.leaderboardData;

      const data = Array.isArray(source?.leaderboard) ? source.leaderboard : [];

      this.top3 = data.slice(0, 3);
      const sliceLimit = this.currentLeaderboard === "stake" ? 15 : 10;
      this.topRest = data.slice(3, sliceLimit);
      this.notFormattedEndDate = source?.endDate || null;

      const key = `VUE_APP_${this.leaderboardEnvKey()}_${
        this.previousLeaderboard ? "PREVIOUS" : "CURRENT"
      }_LEADERBOARD_REWARDS`;

      const rewards = JSON.parse(process.env[key] || "[]");
      this.totalPrize = rewards.reduce((sum, val) => sum + Number(val || 0), 0);
    },
    getRewardValue(rank) {
      const key = `VUE_APP_${this.leaderboardEnvKey()}_${
        this.previousLeaderboard ? "PREVIOUS" : "CURRENT"
      }_LEADERBOARD_REWARDS`;
      const rewards = JSON.parse(process.env[key] || "[]");

      if (rewards.length === 0 || rank >= rewards.length || rewards[rank] === undefined) {
        return this.currentLeaderboard === "raingg" ? "0c" : "$0";
      }
      const val = rewards[rank];
      return this.currentLeaderboard === "raingg" ? `${val}c` : `$${val}`;
    },

    getFormattedTotalPrize() {
      if (!this.totalPrize) return "$0";
      const formatted = this.totalPrize.toLocaleString();
      return this.currentLeaderboard === "raingg" ? `${formatted}c` : `$${formatted}`;
    },

    maskString(str) {
      if (!str || str.length < 2) return str;
      const first = str[0],
        last = str[str.length - 1];
      return `${first}${"*".repeat(str.length - 2)}${last}`;
    },

    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    startTimer() {
      clearInterval(this.timerInterval);

      // Show 0000 if showing previous leaderboard
      if (this.previousLeaderboard) {
        this.days = this.hours = this.minutes = this.seconds = 0;
        this.timer = `0d 0h 0m 0s`;
        return;
      }

      if (!this.notFormattedEndDate) return;

      const periodKey = `VUE_APP_${this.leaderboardEnvKey()}_TIMER_PERIOD`;
      const period = process.env[periodKey] || "week";

      const getNextTargetDate = () => {
        const now = moment().tz("America/New_York");
        let target = moment
          .utc(this.notFormattedEndDate)
          .tz("America/New_York")
          .subtract(1, "second");

        if (now.isAfter(target)) {
          if (period === "week") target.add(1, "week");
          else if (period === "month") target.add(1, "month");
          else if (period === "custom") {
            const days = parseInt(
              process.env[`${this.leaderboardEnvKey()}_CUSTOM_DAYS`] || "7",
              10
            );
            target.add(days, "days");
          }
        }

        return target;
      };

      let targetDate = getNextTargetDate();

      const update = () => {
        const now = moment().tz("America/New_York");
        const diff = targetDate.diff(now);

        if (diff < 0) {
          clearInterval(this.timerInterval);
          this.days = this.hours = this.minutes = this.seconds = 0;
          this.timer = `0d 0h 0m 0s`;
          return;
        }

        const dur = moment.duration(diff);
        this.days = Math.floor(dur.asDays());
        this.hours = dur.hours();
        this.minutes = dur.minutes();
        this.seconds = dur.seconds();

        this.timer = `${this.days}d ${this.hours}h ${this.minutes}m ${this.seconds}s`;
      };

      update();
      this.timerInterval = setInterval(update, 1000);
    },
  },
  mounted() {
    this.fetchLeaderboard();
  },
};
</script>

<style scoped>
.border-gradient {
  border-width: 2px;
  border-style: solid;
  border-image: linear-gradient(to right, #6b75ca, #1bf3ff, #1bf3ff) 1;
}

@keyframes bounce-subtle {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
.animate-bounce-subtle {
  animation: bounce-subtle 2s ease-in-out infinite;
}
</style>
